import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const InsuranceCoverage: React.FC = () => {
  const content = (
    <>
      <h2>Forsikringsdækning</h2>
      <p>
        Forstå hvordan forsikring fungerer når du lejer eller udlejer værktøj gennem DoMore.
      </p>

      <h3>DoMore's forsikringspolitik</h3>
      <p>
        <strong>Vigtigt at vide:</strong> DoMore tilbyder ikke selvstændig forsikring. 
        Værktøj der lejes gennem platformen er typisk dækket af ejerens eksisterende forsikringer.
      </p>

      <h3>Forsikring for udlejere</h3>

      <h4>Din hjemme- eller indboforsikring</h4>
      <p>
        De fleste hjemme- og indboforsikringer dækker:
      </p>
      <ul>
        <li>✅ Tyveri af værktøj</li>
        <li>✅ Skader påført af andre (lejeren)</li>
        <li>✅ Brand, vandskade og andre ulykker</li>
        <li>⚠️ Mulig selvrisiko (typisk 2.500-5.000 DKK)</li>
      </ul>

      <h4>Tjek med dit forsikringsselskab</h4>
      <p>
        Før du begynder at udleje, kontakt din forsikring og spørg:
      </p>
      <ul>
        <li>"Er mit værktøj dækket hvis jeg udlejer det privat?"</li>
        <li>"Hvad er selvrisikoen hvis det bliver beskadiget eller stjålet?"</li>
        <li>"Skal jeg opgradere min police?"</li>
        <li>"Er der begrænsninger i udlejning?"</li>
      </ul>

      <h4>Erhvervsforsikring</h4>
      <p>
        Hvis du udlejer kommercielt:
      </p>
      <ul>
        <li>Du har sandsynligvis brug for erhvervsansvars forsikring</li>
        <li>Dækker typrisk højere beløb</li>
        <li>Specifikt designet til udlejning</li>
        <li>Kan koste mere men giver bedre beskyttelse</li>
      </ul>

      <h3>Forsikring for lejere</h3>

      <h4>Ansvarsforsikring</h4>
      <p>
        Din ansvarsforsikring (del af indboforsikring) dækker:
      </p>
      <ul>
        <li>✅ Skader du utilsigtet forårsager på andres ejendele</li>
        <li>✅ Inkluderer lejet værktøj</li>
        <li>✅ Typisk uden selvrisiko for ansvarsdel</li>
      </ul>

      <h4>Hvad betyder det?</h4>
      <p>
        Hvis du kom til at ødelægge ejerens værktøj:
      </p>
      <ul>
        <li>Din ansvarsforsikring kan dække reparation/udskiftning</li>
        <li>Du anmelder skaden til dit forsikringsselskab</li>
        <li>De vurderer om det var en "ulykke" (dækket) eller "forsømmelighed" (ikke dækket)</li>
      </ul>

      <h3>Hvad er typisk DÆKKET</h3>
      <p>
        Almindelige scenarier:
      </p>

      <h4>For ejere</h4>
      <ul>
        <li>✅ Lejer stjal værktøjet</li>
        <li>✅ Værktøj blev beskadiget ved uheld</li>
        <li>✅ Lejer tabte værktøj</li>
        <li>✅ Brand eller vandskade under leje</li>
        <li>✅ Tredje part skadede værktøjet</li>
      </ul>

      <h4>For lejere</h4>
      <ul>
        <li>✅ Du tabte værktøjet ved et uheld</li>
        <li>✅ Det gik i stykker under normal brug</li>
        <li>✅ Du blev udsat for en ulykke med værktøjet</li>
        <li>✅ Tredje part skadede det mens du lånte det</li>
      </ul>

      <h3>Hvad er typisk IKKE dækket</h3>
      <p>
        Situationer uden dækning:
      </p>

      <h4>For ejere</h4>
      <ul>
        <li>❌ Normal slitage</li>
        <li>❌ Eksisterende skader</li>
        <li>❌ Manglende vedligeholdelse</li>
        <li>❌ Skader under kommercielt udlej uden erhvervsforsikring</li>
      </ul>

      <h4>For lejere</h4>
      <ul>
        <li>❌ Forsætlige skader</li>
        <li>❌ Grov uagtsomhed (f.eks. efterladt ulåst)</li>
        <li>❌ Brug til ikke-tiltænkt formål</li>
        <li>❌ Misbrug eller overdreven kraft</li>
      </ul>

      <h3>Selvrisiko</h3>
      <p>
        Forstå selvrisiko ved forsikringskrav:
      </p>
      <ul>
        <li>De fleste indboforsikringer har 2.500-5.000 DKK selvrisiko</li>
        <li>Det betyder du betaler de første 2.500-5.000 DKK selv</li>
        <li>Forsikringen dækker resten</li>
        <li>For små skader (under selvrisiko) er det ikke værd at anmelde</li>
      </ul>

      <h4>Eksempel</h4>
      <blockquote>
        En borehammer til 3.000 DKK går i stykker. Din selvrisiko er 2.500 DKK. 
        Du betaler 2.500 DKK, forsikringen betaler 500 DKK. 
        I dette tilfælde er det næsten som at betale selv.
      </blockquote>

      <h3>Depositum som sikkerhed</h3>
      <p>
        Mange ejere bruger depositum i stedet for forsikring:
      </p>
      <ul>
        <li>Dækker mindre skader uden forsikringsanmeldelse</li>
        <li>Undgår selvrisiko</li>
        <li>Hurtigere løsning</li>
        <li>Typisk sat til værktøjets værdi eller en del af den</li>
      </ul>

      <h4>Sådan fungerer det</h4>
      <ol>
        <li>Lejer betaler depositum ved afhentning</li>
        <li>Hvis værktøj returneres OK: depositum returneres</li>
        <li>Hvis værktøj er beskadiget: ejer beholder hele eller dele til reparation</li>
        <li>Ved total skade: depositum + forsikring kan bruges</li>
      </ol>

      <h3>Hvad gør du ved skader?</h3>

      <h4>Som lejer (du forårsagede skaden)</h4>
      <ol>
        <li><strong>Informér ejeren omgående:</strong> Vær ærlig om hvad der skete</li>
        <li><strong>Dokumentér:</strong> Tag billeder af skaden</li>
        <li><strong>Diskutér løsning:</strong> Kan det repareres? Hvad koster det?</li>
        <li><strong>Overvej depositum:</strong> Er det nok til at dække?</li>
        <li><strong>Kontakt din forsikring:</strong> Hvis depositum ikke dækker</li>
        <li><strong>Anmeld krav:</strong> Med dokumentation</li>
      </ol>

      <h4>Som ejer (dit værktøj blev beskadiget)</h4>
      <ol>
        <li><strong>Dokumentér skaden:</strong> Billeder og beskrivelse</li>
        <li><strong>Få reparationstilbud:</strong> Hvad koster det at fixe?</li>
        <li><strong>Diskutér med lejer:</strong> Kan depositum dække?</li>
        <li><strong>Hvis ikke nok:</strong> Bed lejer kontakte deres forsikring</li>
        <li><strong>Alternativt:</strong> Anmeld på din egen forsikring</li>
        <li><strong>Gem dokumentation:</strong> DoMore chat, billeder, kvitteringer</li>
      </ol>

      <h3>Forsikringskrav proces</h3>

      <h4>Trin 1: Dokumentation</h4>
      <p>
        Saml:
      </p>
      <ul>
        <li>Billeder af skaden</li>
        <li>Kvitteringer for værktøjets værdi</li>
        <li>DoMore booking detaljer</li>
        <li>Chat historik</li>
        <li>Reparationstilbud eller udskiftningsomkostninger</li>
      </ul>

      <h4>Trin 2: Kontakt forsikring</h4>
      <ul>
        <li>Ring eller brug deres online portal</li>
        <li>Forklar situationen</li>
        <li>Medgiv al dokumentation</li>
      </ul>

      <h4>Trin 3: Vurdering</h4>
      <ul>
        <li>Forsikringen vurderer kravet</li>
        <li>Kan anmode om mere information</li>
        <li>Beslutter om det er dækket</li>
      </ul>

      <h4>Trin 4: Udbetaling</h4>
      <ul>
        <li>Hvis godkendt, får du erstatning minus selvrisiko</li>
        <li>Typisk inden 1-2 uger</li>
      </ul>

      <h3>Tips til at beskytte dig selv</h3>

      <h4>For ejere</h4>
      <ul>
        <li>Verificér at dit værktøj er forsikret før udlejning</li>
        <li>Tag detaljerede billeder FØR hver udlejning</li>
        <li>Kræv depositum for dyrt værktøj</li>
        <li>Udlej kun til lejere med gode ratings</li>
        <li>Lav skriftlig aftale i DoMore chat</li>
        <li>Verificér lejerens identitet</li>
      </ul>

      <h4>For lejere</h4>
      <ul>
        <li>Bekræft at du har ansvarsforsikring</li>
        <li>Inspicér værktøj ved afhentning</li>
        <li>Tag billeder af enhver eksisterende skade</li>
        <li>Brug værktøj ansvarligt</li>
        <li>Opbevar det sikkert</li>
        <li>Rapportér problemer med det samme</li>
      </ul>

      <h3>Yderligere forsikring muligheder</h3>

      <h4>Specialforsikring for værktøj</h4>
      <p>
        Nogle forsikringsselskaber tilbyder:
      </p>
      <ul>
        <li>Dedikeret værktøjsforsikring</li>
        <li>Lavere selvrisiko</li>
        <li>Dækning udenfor hjemmet</li>
        <li>Kommerciel udlejningsdækning</li>
      </ul>

      <h4>Er det værd det?</h4>
      <p>
        Overvej specialforsikring hvis:
      </p>
      <ul>
        <li>Du har meget dyrt værktøj (10.000+ DKK)</li>
        <li>Du udlejer ofte</li>
        <li>Du vil have lavere selvrisiko</li>
        <li>Din standard forsikring ikke dækker udlejning</li>
      </ul>

      <h3>Ofte stillede spørgsmål</h3>

      <h4>Stiger min præmie hvis jeg anmelder skade?</h4>
      <p>
        Det afhænger af forsikringsselskabet og din historik. Gentagne krav kan påvirke præmien.
      </p>

      <h4>Hvad hvis lejer nægter at betale for skader?</h4>
      <p>
        Kontakt DoMore support. Vi kan mægle. Hvis det ikke virker, kontakt din forsikring eller overvej juridiske skridt.
      </p>

      <h4>Dækker DoMore noget?</h4>
      <p>
        Nej, DoMore er en platform og er ikke ansvarlig for værktøj eller transaktioner mellem brugere.
      </p>

      <h4>Skal jeg fortælle min forsikring om udlejning?</h4>
      <p>
        Ja, det er bedst at informere dem på forhånd for at sikre dækning.
      </p>

      <h3>Konklusion</h3>
      <p>
        Forsikring giver tryghed, men forebyggelse er bedst:
      </p>
      <ul>
        <li>Vælg pålidelige brugere (tjek ratings)</li>
        <li>Dokumentér alt</li>
        <li>Kommunikér klart</li>
        <li>Brug depositum</li>
        <li>Behandl hinandens ejendele med respekt</li>
      </ul>
    </>
  );

  return (
    <HelpArticle
      title="Forsikringsdækning"
      category="Populært"
      content={content}
      relatedArticles={[
        { title: 'Hvad sker der hvis et værktøj går i stykker?', link: '/help/tool-damage' },
        { title: 'Afhentning og returnering', link: '/help/pickup-return' },
      ]}
    />
  );
};

export default InsuranceCoverage;
